<template>
  <v-card outlined class="pa-0">
    <v-form ref="formFacturar">
    <v-card-title class="subtitle-2 font-weight-bold py-2 px-3">
      Datos de factura
    </v-card-title>

    <v-divider />

    <v-card-text class="pa-2">
      <v-row dense>
        <v-col cols="12" md="4">
          <v-text-field :value="value.rfc" label="RFC" outlined dense clearable hide-details class="mt-0"
            @input="updateField('rfc', $event)" @click:clear="clearField('rfc')" 
            :rules="[ rules.ruleRequired, rules.ruleRfc]"/>
        </v-col>
        <v-col cols="12" md="8">
          <v-text-field :value="value.nombre" label="Nombre o razón social" outlined dense clearable hide-details
            class="mt-0" @input="updateField('nombre', $event)" @click:clear="clearField('nombre')"
            :rules="[ rules.ruleRequired]" />
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field :value="value.claveProducto" label="Clave producto" outlined dense clearable hide-details
            class="mt-0" @input="updateField('claveProducto', $event)" @click:clear="clearField('claveProducto')"
            :rules="[ rules.ruleRequired]" />
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field :value="value.regimenFiscalReceptor" label="Régimen fiscal receptor" outlined dense clearable
            hide-details class="mt-0" @input="updateField('regimenFiscalReceptor', $event)"
            @click:clear="clearField('regimenFiscalReceptor')" :rules="[ rules.ruleRequired]"/>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field :value="value.usoCfdi" label="Uso CFDI" outlined dense clearable hide-details class="mt-0"
            @input="updateField('usoCfdi', $event)" @click:clear="clearField('usoCfdi')" :rules="[ rules.ruleRequired]"/>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field :value="value.noIdentificacion" label="No. identificación" outlined dense clearable hide-details
            class="mt-0" @input="updateField('noIdentificacion', $event)"
            @click:clear="clearField('noIdentificacion')" :rules="[ rules.ruleRequired]"/>
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field :value="value.claveUnidad" label="Clave unidad" outlined dense clearable hide-details
            class="mt-0" @input="updateField('claveUnidad', $event)" @click:clear="clearField('claveUnidad')"
            :rules="[ rules.ruleRequired]" />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field :value="value.unidad" label="Unidad" outlined dense clearable hide-details class="mt-0"
            @input="updateField('unidad', $event)" @click:clear="clearField('unidad')" :rules="[ rules.ruleRequired]" />
        </v-col>

        <v-col cols="12">
          <v-textarea :value="value.descripcionProducto" label="Descripción producto" outlined dense clearable auto-grow
            rows="4" counter="400" maxlength="400" class="mt-0" @input="updateField('descripcionProducto', $event)"
            @click:clear="clearField('descripcionProducto')" :rules="[ rules.ruleRequired]" />
        </v-col>

        <v-col cols="12" md="6">
          <v-select :items="formasPago" item-value="clave" item-text="etiqueta" :value="value.formaPago"
            label="Forma de pago" outlined dense clearable hide-details class="mt-0" :rules="[ rules.ruleRequired]"
            @change="updateField('formaPago', $event)" @click:clear="clearField('formaPago')" />
        </v-col>


    <v-col cols="12" md="3">
      <v-text-field
        :value="subtotalCalculado"
        label="Subtotal"
        outlined
        dense
        readonly
        hide-details
        prefix="$"
        class="mt-0"
        disabled
      />
    </v-col>

    <v-col cols="12" md="3">
      <v-text-field
        :value="ivaCalculado"
        label="IVA"
        outlined
        dense
        readonly
        hide-details
        prefix="$"
        class="mt-0"
        disabled
      />
    </v-col>

    <v-col cols="12" md="3">
      <v-text-field
        :value="value.total"
        :rules="[ rules.ruleRequired, rules.ruleTotalMayorCero]"
        label="Total"
        type="number"
        outlined
        dense
        clearable
        hide-details
        prefix="$"
        class="mt-0"
        @input="updateField('total', $event)"
        @click:clear="clearField('total')"
      />
    </v-col>


        <v-col cols="12" md="8">
          <v-text-field :value="correoEnvio" label="Correo de envío" outlined dense clearable hide-details
            prepend-inner-icon="mdi-email" :rules="[rules.ruleEmail, rules.ruleRequired]" class="mt-0"
            @input="updateField('correoEnvio', $event)" @click:clear="clearField('correoEnvio')" />
        </v-col>
      </v-row>
      <v-divider />

      <v-card-actions class="pa-2 justify-end">
        <v-btn small text color="grey darken-1" class="px-3" @click="limpiarFormulario"
         :disabled="loading">
          <v-icon small left>
            mdi-broom
          </v-icon>
          Limpiar
        </v-btn>

        <v-btn small depressed color="primary" class="px-4" @click="btnFacturar"
         :disabled="loading">
    <v-icon
      v-if="!loading"
      small
      left
    >
      mdi-file-send-outline
    </v-icon>

    {{ loading ? 'Facturando... un momento' : 'Facturar' }}
        </v-btn>
      </v-card-actions>
    </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'FacturarForm',

  props: {
    value: {
      type: Object,
      required: true
    },
    formasPago: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters(['getEmail']),

    rules() {
      return this.$rules;
    },

    correoEnvio() {
      return this.value.correoEnvio || this.getEmail || '';
    },

    totalNumerico() {
    return Number(this.value.total || 0);
  },

  subtotalCalculado() {
    if (!this.totalNumerico) {
      return 0;
    }

    return Number((this.totalNumerico / 1.16).toFixed(2));
  },

  ivaCalculado() {
    if (!this.totalNumerico) {
      return 0;
    }

    return Number((this.totalNumerico - this.subtotalCalculado).toFixed(2));
  }
  },

  mounted() {
    if (!this.value.correoEnvio && this.getEmail) {
      this.updateField('correoEnvio', this.getEmail);
    }
  },

  methods: {
    limpiarFormulario() {
      this.$emit('input', this.getFormularioVacio());
      this.$emit('limpiar');

      this.$nextTick(() => {
        if (this.$refs.formFacturar) {
          this.$refs.formFacturar.resetValidation();
        }
      });
    },
    getFormularioVacio() {
      return {
      rfc: '',
      claveProducto: '',
      regimenFiscalReceptor: '',
      usoCfdi: '',
      noIdentificacion: '',
      claveUnidad: '',
      unidad: '',
      descripcionProducto: '',
      formaPago: '',
      total: '',
      correoEnvio: this.getEmail || ''
      };
    },

    getDetalleVacio() {
      return {
        claveProducto: '',
        noIdentificacion: '',
        descripcionProducto: '',
        unidad: '',
        cantidad: 1,
        total: ''
      };
    },
    updateField(field, fieldValue) {
      this.$emit('input', {
        ...this.value,
        [field]: fieldValue
      });
    },

    clearField(field) {
      this.updateField(field, '');
    },

    btnFacturar() {
      if (this.loading) {
        return;
      }

      const valido = this.$refs.formFacturar
        ? this.$refs.formFacturar.validate()
        : true;

      if (!valido) {
        return;
      }

      const request = this.construirRequest();

      this.$emit('facturar', request);
    },
    construirRequest() {
      return {
        RfcReceptor: this.value.rfc || '',
        NombreCliente: this.value.nombre || '',
        UsoCfdi: this.value.usoCfdi || '',
        RegimenFiscal: this.value.regimenFiscalReceptor || '',
        CodigoPostal: this.value.codigoPostal || this.value.cp || '',
        MetodoPago: this.value.formaPago || '',
        Correo: this.value.correoEnvio || this.getEmail || '',
        Detalles: [
          {
            ClaveProdServ: this.value.claveProducto || '',
            NoIdentificacion: this.value.noIdentificacion || null,
            Descripcion: this.value.descripcionProducto || '',
            Unidad: this.value.unidad || '',
            Cantidad: 1,
            ValorUnitario: this.subtotalCalculado,
            Iva: this.ivaCalculado
          }
        ]
      };
    }
  }
};
</script>